(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/needs-unlock.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/needs-unlock.js');
'use strict';

const NeedsUnlock = _ref => {
  let {
    phone
  } = _ref;
  return React.createElement("i", null, "Om du har en spelpaus som \xE4r l\xE4ngre \xE4n ett \xE5r beh\xF6ver du ringa v\xE5r kundservice p\xE5", ' ', React.createElement("a", {
    className: "no-wrap fc-sport-75",
    href: phone
  }, "0770 11 11 11"), ' ', "f\xF6r att l\xE5sa upp ditt spelkonto n\xE4r spelpausen \xE4r slut.");
};
svs.selfExclusion.components.NeedsUnlock = NeedsUnlock;

 })(window);